import { getToken } from "../../../common/environment_config.es6";

// One request per training per page load; failures resolve null and are not cached.
let cache = {};

export const __resetSlideNotes = () => {
  cache = {};
};

export const loadSlideNotes = (trainingId) => {
  if (!trainingId) return Promise.resolve(null);
  if (!cache[trainingId]) {
    cache[trainingId] = fetch(
      `${process.env.MW_API_URL}api/ideal-studio/files?idealStudioTrainingId=${encodeURIComponent(
        trainingId
      )}&fileType=slide-notes&limit=1`,
      { headers: { Authorization: `Bearer ${getToken()}` } }
    )
      .then((res) => {
        if (!res.ok) throw new Error(`slide-notes ${res.status}`);
        return res.json();
      })
      .then((json) => json?.files?.[0]?.metadata?.notesByNavId || null)
      .catch(() => {
        delete cache[trainingId];
        return null;
      });
  }
  return cache[trainingId];
};

export const noteForScene = (notesByNavId, sceneId) => {
  const note = notesByNavId?.[sceneId];
  return typeof note === "string" && note.trim() ? note.trim() : null;
};

// Notes in scene order: [{ navId, title, text }]
export const slideNotesInOrder = (notesByNavId, navItemsIds, navItems) =>
  (navItemsIds || []).reduce((acc, navId) => {
    const text = noteForScene(notesByNavId, navId);
    if (text) acc.push({ navId, title: navItems?.[navId]?.name || navId, text });
    return acc;
  }, []);

export const buildSummaryCopyText = (summary, entries, heading) => {
  const parts = [];
  if (summary) parts.push(summary);
  if (entries.length) {
    parts.push(heading, entries.map((e) => `${e.title}\n${e.text}`).join("\n\n"));
  }
  return parts.join("\n\n");
};
